module.exports = __webpack_public_path__ + "01dc71a2a5728b06e99857caecdfbc37.jpg";